const translation = {
  // ─── Layout ───────────────────────────────────────────────────────────────
  "nav.analytics": "Analytics",
  "nav.recommendations": "Recommendations",
  "nav.feedback": "Feedback",
  "layout.adminConsole": "Admin Console",
  "layout.logout": "Sign Out",
  "layout.logoutConfirm": "Confirm to sign out?",
  "layout.loggingOut": "Signing out...",
  "layout.confirmYes": "Confirm",
  "layout.confirmNo": "Cancel",

  // ─── Common ───────────────────────────────────────────────────────────────
  "common.all": "All",
  "common.active": "Active",
  "common.inactive": "Inactive",
  "common.cancel": "Cancel",
  "common.close": "Close",
  "common.clear": "Clear",
  "common.confirm": "Confirm",
  "common.filter": "Filter",
  "common.dateRange": "Date Range",
  "common.save": "Save",
  "common.edit": "Edit",
  "common.remove": "Remove",
  "common.required": "Required",
  "common.delete": "Delete",
  "common.details": "Details",
  "common.viewDetails": "View details",
  "common.note": "Note",
  "common.actions": "Actions",
  "common.status": "Status",
  "common.type": "Type",
  "common.total": "Total",
  "common.helpful": "Helpful",
  "common.unhelpful": "Unhelpful",
  "common.export": "Export",
  "common.items": "items",
  "common.loadError": "Failed to load data",
  "common.saveError": "Failed to save",
  "common.exportError": "Failed to export",
  "common.search": "Search",
  "common.backToList": "Back to List",
  "common.onTarget": "On Target",
  "common.belowTarget": "Below Target",
  "common.today": "Today",
  "common.thisMonth": "This Month",
  "common.last7Days": "Last 7 Days",
  "common.last30Days": "Last 30 Days",
  "common.customRange": "Custom Range",
  "common.manual": "Manual",
  "common.auto": "Auto",
  "common.combined": "Combined",
  "common.clicks": "Clicks",
  "common.queries": "Queries",
  "common.source": "Source",
  "common.topic": "Topic",
  "common.allTopics": "All Topics",
  "common.pinned": "Pinned",
  "common.personalized": "Personalized",
  "common.globalTrending": "Global Trending",
  "common.collapse": "Collapse",
  "common.expand": "Expand",
  "common.expandDetails": "Expand for details",
  "common.noDataFound": "No matching records found",
  "common.noData": "No data available",
  "common.loading": "Loading...",
  "common.users": "Users",
  "common.study": "study",
  "common.studies": "studies",
  "common.saving": "Saving...",
  "common.add": "Add",
  "common.adding": "Adding...",
  "common.deleting": "Deleting...",
  "common.reset": "Reset",
  "common.retry": "Retry",
  "common.back": "Back",
  "common.pagination.range": "Showing {{from}} - {{to}} of {{total}}",
  "common.pagination.previous": "Previous page",
  "common.pagination.next": "Next page",
  "common.pagination.page": "Page {{page}}",
  "common.pagination.pageNumber": "Page number",

  // ─── Feedback List ────────────────────────────────────────────────────────
  "feedback.title": "Answer Feedback",
  "feedback.subtitle": "View and analyze user feedback on AI answers",
  "feedback.overview": "Feedback Overview",
  "feedback.unhelpfulRate": "Unhelpful Rate",
  "feedback.helpfulRate": "Helpful Rate",
  "feedback.target": "Target",
  "feedback.targetBelow2": "Target < 2%",
  "feedback.targetAbove95": "Target > 95%",
  "feedback.searchPlaceholder": "Search question or conversation ID...",
  "feedback.filterType": "Type",
  "feedback.allTypes": "All Types",
  "feedback.feedbackTime": "Feedback Time",
  "feedback.questionTitle": "Question Title",
  "feedback.conversationId": "Conversation ID",
  "feedback.user": "User",
  "feedback.sourceDocs": "Source Docs",
  "feedback.reason": "Reason",
  "feedback.noRecords": "No feedback records found",
  "feedback.addNote": "Add Note",
  "feedback.feedbackId": "Feedback ID",
  "feedback.notePlaceholder": "Enter internal note (visible to admins only)...",
  "feedback.saveNote": "Save Note",
  "feedback.reasonPlaceholder": "e.g. Answer was incomplete, missing key details...",
  "feedback.clickToEdit": "Click to edit reason",
  "feedback.totalAnswers": "Total Answers",
  "feedback.totalAnswersDesc": "AI-generated answers in total",
  "feedback.feedbackCount": "Total Feedback",
  "feedback.feedbackRate": "Feedback Rate",
  "feedback.feedbackRateDesc": "Feedback / Total Answers",
  "feedback.feedbackRateTooltip":
    "Answers with feedback ÷ total AI answers × 100%. Measures how actively users rate AI responses.",
  "feedback.helpfulRateTooltip":
    'Answers marked "Helpful" ÷ total feedback count × 100%. Measures the proportion of users satisfied with AI answers.',
  "feedback.unhelpfulRateTooltip":
    'Answers marked "Unhelpful" ÷ total feedback count × 100%. Measures the proportion of users dissatisfied with AI answers.',
  "feedback.helpfulShort": "Helpful {{count}}",
  "feedback.unhelpfulShort": "Unhelpful {{count}}",

  // ─── Feedback Detail ──────────────────────────────────────────────────────
  "feedbackDetail.title": "Feedback Detail",
  "feedbackDetail.subtitle": "View full feedback context and related information",
  "feedbackDetail.notFound": "Feedback record not found",
  "feedbackDetail.basicInfo": "Basic Information",
  "feedbackDetail.feedbackTime": "Feedback Time",
  "feedbackDetail.conversationId": "Conversation ID",
  "feedbackDetail.username": "Username",
  "feedbackDetail.sourceDocuments": "Source Documents",
  "feedbackDetail.documents": "documents",
  "feedbackDetail.userQuestion": "User Question",
  "feedbackDetail.systemAnswer": "System Answer",
  "feedbackDetail.sourceDocsSection": "Source Documents",
  "feedbackDetail.viewDocument": "View Document",
  "feedbackDetail.noSourceDocs": "No source documents",
  "feedbackDetail.unhelpfulReason": "Reason for Unhelpful",
  "feedbackDetail.userComments": "User Comments",
  "feedbackDetail.internalNote": "Internal Note",
  "feedbackDetail.editNote": "Edit Note",
  "feedbackDetail.notePlaceholder":
    "Add internal notes for issue analysis and follow-up records...",
  "feedbackDetail.noNote": "No internal notes",
  "feedbackDetail.noteSaved": "Note saved",

  // ─── Analytics ────────────────────────────────────────────────────────────
  "analytics.title": "Analytics Overview",
  "analytics.subtitle": "Monitor system performance and user engagement",
  "analytics.penetrationSection": "AI Usage Penetration",
  "analytics.qualitySection": "AI Operations Quality",
  "analytics.currentWeek": "Current Week",
  "analytics.weeklyPenetrationTrend": "8-Week Penetration Trend",
  "analytics.weeklyPenetrationTrendTooltip":
    "Week-over-week trend of active user rate and highly engaged rate, calculated by natural week. Reflects how user activity changes over time.",
  "analytics.activeUserRate": "Active User Rate",
  "analytics.activeUserTooltip":
    "Active user: interacts with AI > 3 times per week. Active user rate = active users / total registered users. Target > 50%.",
  "analytics.activeUserTooltipNew":
    "Calculated by calendar week. Active User Rate = users with \u22653 AI interactions that week \u00f7 eligible users. Eligible users exclude those whose only roles are Admin and/or Auditor. Target >50%.",
  "analytics.highlyEngagedRate": "Highly Engaged Rate",
  "analytics.highlyEngagedTooltip":
    "Highly engaged user: interacts with AI > 10 times per week. Engagement rate = highly engaged users / total registered users. Target > 20%.",
  "analytics.highlyEngagedTooltipNew":
    "Calculated by calendar week. High Engagement Rate = users with \u226510 AI interactions that week \u00f7 eligible users. Eligible users exclude those whose only roles are Admin and/or Auditor. Target >20%.",
  "analytics.helpfulRate": "Helpful Rate",
  "analytics.helpfulRateTooltip":
    "Helpful answer: AI answers marked as helpful by users. Helpful rate = helpful answers / total answers. Higher is better, target > 95%.",
  "analytics.helpfulRateTooltipNew":
    "Helpful feedback in selected period ÷ total answer submitted in selected period.",
  "analytics.unhelpfulRate": "Unhelpful Rate",
  "analytics.unhelpfulRateTooltip":
    "Unhelpful answer: AI answers marked as unhelpful by users. Unhelpful rate = unhelpful answers / total answers. Lower is better, target < 2%.",
  "analytics.unhelpfulRateTooltipNew":
    "Unhelpful feedback in selected period ÷ total answer submitted in selected period. Lower is better, target < 2%.",
  "analytics.engagementTrend": "User Engagement Trend",
  "analytics.engagementTrendTooltip":
    "Time-series view of active user rate and engagement rate. Useful for identifying user activity cycles and fluctuations.",
  "analytics.activeUserRateLabel": "Active User Rate",
  "analytics.engagementRateLabel": "Engagement Rate",
  "analytics.satisfaction": "User Satisfaction",
  "common.neutral": "Neutral",
  "analytics.satisfactionTooltip":
    "User satisfaction = helpful answers / total feedback received. Reflects overall user satisfaction with AI responses. Higher is better.",
  "analytics.satisfactionTooltipNew":
    "Helpful answers in selected period ÷ total answer in selected period. Reflects overall user satisfaction with AI responses. Higher is better.",
  "analytics.satisfactionLabel": "Satisfaction",
  "analytics.totalFeedback": "Total Feedback",
  "analytics.totalAnswer": "Total Answer",
  "analytics.responseTime": "Response Time",
  "analytics.responseTimeTooltip":
    "Uses P75 and P95 percentiles to measure response latency. Short-term target: 75% of responses < 15s; Long-term target: 95% of responses < 15s.",
  "analytics.responseTimeLabel": "Response Time",
  "analytics.shortTermGoal": "Short-term Target (P75)",
  "analytics.longTermGoal": "Long-term Target (P95)",
  "analytics.p75Tooltip":
    "75% of responses complete within this time. This is the short-term target, reflecting the experience of the majority of users under normal load.",
  "analytics.p95Tooltip":
    "95% of responses complete within this time. This is the long-term target, covering slow-request scenarios to reflect the full range of user experience.",
  "analytics.targetWithin": "Target <",
  "analytics.recentTrend": "Last 8 Days",
  "analytics.avgResponseTime": "Avg. Response Time",
  "analytics.below15sRate": "Response <15s Rate",
  "analytics.p75LatencyDesc": "P75 latency",
  "analytics.p95LatencyDesc": "P95 latency",
  "analytics.unhelpfulReasonDist": "Unhelpful Reason Distribution",
  "analytics.unhelpfulReasonTooltip":
    "Reasons users select when marking an answer as unhelpful. Helps identify main AI response weaknesses to guide model optimization.",
  "analytics.share": "Target",
  "analytics.count": "Count",

  // Admin - Studies
  "studies.title": "Study Management",
  "studies.subtitle":
    "Manage all clinical study projects. View details, assign CRAs, and create new projects.",
  "studies.newStudy": "New Study",
  "studies.searchPlaceholder": "Search by name, code, or CRA...",
  "studies.searchBtn": "Search",
  "studies.reset": "Reset",
  "studies.table.name": "Study Name",
  "studies.table.code": "Study Code",
  "studies.table.cra": "Assigned CRA",
  "studies.table.members": "Members",
  "studies.table.createdAt": "Created At",
  "studies.table.actions": "Actions",
  "studies.table.reports": "reports",
  "studies.table.noResults": "No studies found",
  "studies.table.noResultsHint": "Try adjusting your search or filter criteria",
  "studies.detail.title": "Study Details",
  "studies.detail.studyName": "Study Name",
  "studies.detail.studyCode": "Study Code",
  "studies.detail.cra": "Assigned CRA",
  "studies.detail.createdAt": "Created At",
  "studies.detail.reports": "Reports",
  "studies.detail.close": "Close",
  "studies.detail.notFound": "Study not found",
  "studies.detail.tabMembers": "Members",
  "studies.detail.tabSources": "Sources",
  "studies.detail.membersCount": "{{count}} members",
  "studies.detail.membersEmpty": "No members",
  "studies.detail.membersEmptyHint":
    "This Study has no members. Auto Sync members will be synced from Teams / SharePoint automatically. You can also manually add CRAs.",
  "studies.detail.membersLoadFailed": "Failed to load Study members.",
  "studies.detail.memberSearchPlaceholder": "Search member name or email...",
  "studies.detail.dgSync": "DG Sync Settings",
  "studies.detail.dgModalTitle": "Configure Distribution Group Sync",
  "studies.detail.dgStatus": "Sync Status",
  "studies.detail.dgStatusEnabled": "Enabled",
  "studies.detail.dgStatusEnabledDesc": "Enabled: Participate in scheduled synchronization.",
  "studies.detail.dgStatusDisabled": "Disabled",
  "studies.detail.dgStatusDisabledDesc":
    "Disabled: Saving immediately triggers a sync to remove this group's member access. Members with other sources remain in the Study.",
  "studies.detail.dgEmail": "Distribution Group Email",
  "studies.detail.dgEmailPlaceholder": "e.g. study-group@company.com",
  "studies.detail.dgIncludeNested": "Include Nested Groups",
  "studies.detail.dgDescription": "Description",
  "studies.detail.dgDescriptionPlaceholder":
    "Enter description for this distribution group sync...",
  "studies.detail.dgSaveAndSync": "Save & Sync",
  "studies.detail.dgNestedTooltip":
    "Recursively retrieve users from nested distribution groups. GroupMember.Read.All permission is required.",
  "studies.detail.dgDetailTitle": "Distribution Group Sync",
  "studies.detail.dgLastSyncTime": "Last Sync Time",
  "studies.detail.dgLastSynced": "Last synced",
  "studies.detail.dgLastSyncStatus": "Last Sync Status",
  "studies.detail.dgSyncedUserCount": "Synced User Count",
  "studies.detail.dgSyncSuccess": "Sync Success",
  "studies.detail.dgSyncFailed": "Sync Failed",
  "studies.detail.dgSyncing": "Syncing...",
  "studies.detail.dgSyncingHint": "Syncing members from the distribution group.",
  "studies.detail.dgSyncingToast":
    "Sync started. Syncing members from the distribution group in the background...",
  "studies.detail.dgYes": "Yes",
  "studies.detail.dgNo": "No",
  "studies.detail.dgEdit": "Edit",
  "studies.detail.dgDisable": "Disable",
  "studies.detail.dgEnable": "Enable",
  "studies.detail.dgDisableTitle": "Disable Distribution Group Sync?",
  "studies.detail.dgDisableDesc":
    "This will disable the distribution group and immediately trigger a sync. After a successful sync, members with no other sources will be removed from this Study.",
  "studies.detail.dgSaveFailed": "Failed to save Distribution Group sync settings.",
  "studies.detail.addMember": "Add Member",
  "studies.detail.addMemberTitle": "Add Manual Member",
  "studies.detail.addMemberDesc":
    "Manually added CRA will gain access to all Sources under this Study. Manual membership takes priority over auto-sync.",
  "studies.detail.addMemberSearch": "Search CRA users...",
  "studies.detail.addMemberSearchHint": "Enter an ITCode or email to search.",
  "studies.detail.addMemberSearching": "Searching CRA users...",
  "studies.detail.addMemberNoResults": "No matching CRA users found",
  "studies.detail.addMemberAlreadyAssigned": "Already assigned",
  "studies.detail.addMemberConfirm": "Confirm Add",
  "studies.detail.removeMemberTitle": "Remove Member",
  "studies.detail.removeMemberDesc":
    "Remove {{name}} from this Study's member list. Auto Sync members cannot be manually removed.",
  "studies.detail.removeMemberConfirm": "Confirm Remove",
  "studies.detail.tagAutoSync": "Auto Sync",
  "studies.detail.tagManual": "Manual",
  "studies.detail.colName": "Name",
  "studies.detail.colEmail": "Email",
  "studies.detail.colSource": "Source",
  "studies.detail.colAddedAt": "Added At",
  "studies.detail.paginationPrevious": "Previous page",
  "studies.detail.paginationNext": "Next page",
  "studies.detail.paginationPage": "Page {{page}}",
  "studies.detail.colAction": "Action",
  "studies.detail.sourcesEmpty": "No sources",
  "studies.detail.sourcesEmptyHint":
    "This Study has no sources configured. Go to Study Source Settings to add sources.",
  "studies.detail.colConnection": "Connection",
  "studies.detail.colChannelName": "Source Site",
  "studies.detail.colUserListSync": "User List Sync",
  "studies.detail.userListSourceYes": "Yes",
  "studies.detail.userListSourceNo": "No",
  "studies.detail.memberSource.teams": "Teams Channel",
  "studies.detail.memberSource.sharepoint": "SharePoint Site",
  "studies.detail.memberSource.dg": "DG",
  "studies.detail.view": "View",
  "studies.detail.sourceFilter.all": "All Sources",
  "studies.detail.filterNoResults": "No members match this source filter",
  "studies.modal.title": "Create New Study",
  "studies.modal.editTitle": "Edit Study",
  "studies.modal.studyName": "Study Name",
  "studies.modal.studyNameRequired": "*",
  "studies.modal.studyNamePlaceholder": "e.g., eVolve Meso Phase II",
  "studies.modal.studyCode": "Study Code",
  "studies.modal.studyCodeRequired": "*",
  "studies.modal.studyCodePlaceholder": "e.g., D7986C0001",
  "studies.modal.associatedCra": "Associated CRA",
  "studies.modal.optional": "(Optional)",
  "studies.modal.searchMoreCra": "Search more...",
  "studies.modal.searchCraPlaceholder": "Search by name or email...",
  "studies.modal.noMatchingCra": "No matching user found",
  "studies.modal.allCraSelected": "All users have been selected",
  "studies.modal.saveFailed": "Failed to save study",
  "studies.modal.cancel": "Cancel",
  "studies.modal.create": "Create Study",
  "studies.toast.created": "Study created successfully",
  "studies.toast.updated": "Study updated successfully",
  "studies.more": "more",
  "studies.showLess": "Show Less",
  "studies.loadFailed": "Failed to load studies",
  "studies.detailLoadFailed": "Failed to load study details",
  "studies.craLoadFailed": "Failed to load CRA users",
  "studies.pagination": "Showing {{from}} - {{to}} of {{total}}",

  // Admin - Users
  "users.title": "User & Permission",
  "users.subtitle":
    "Users are sourced from AZ SSO. Assign roles and control access to study document sources for each user.",
  "users.addUser": "Add User",
  "users.searchPlaceholder": "Search by name, email, or K account...",
  "users.searchBtn": "Search",
  "users.role": "Role",
  "users.role.all": "All Roles",
  "users.role.staff": "Staff",
  "users.role.cra": "CRA",
  "users.role.csm": "CSM",
  "users.role.admin": "Admin",
  "users.role.auditor": "Auditor",
  "users.role.manager": "Manager",
  "users.status": "Status",
  "users.status.all": "All Statuses",
  "users.table.user": "User",
  "users.table.studies": "Studies",
  "users.table.statusLastActive": "Status / Last Active",
  "users.table.actions": "Actions",
  "users.table.noResults": "No users found",
  "users.table.noResultsHint": "Try adjusting your search or filter criteria",
  "users.table.edit": "Edit Permissions",
  "users.table.disable": "Disable User",
  "users.table.enable": "Enable User",
  "users.table.noAccess": "No system access",
  "users.table.noLocalRole": "No role assigned",
  "users.table.showLess": "Show Less",
  "users.table.more": "More",
  "users.table.site": "site",
  "users.table.sites": "sites",
  "users.stats.totalUsers": "Total Users",
  "users.stats.active": "Active",
  "users.stats.inactive": "Inactive",
  "users.stats.byRole": "By Role",
  "users.stats.percentOfTotal": "{pct}% of total",
  "users.status.active": "Active",
  "users.status.inactive": "Inactive",
  "users.status.disabled": "Disabled",
  "users.modal.title": "Add User",
  "users.modal.subtitle": "Enter a K-Account to import from AZ SSO",
  "users.modal.kAccount": "K-Account",
  "users.modal.kAccountRequired": "*",
  "users.modal.kAccountPlaceholder": "e.g., smithj01",
  "users.modal.verify": "Verify",
  "users.modal.verifying": "Verifying...",
  "users.modal.verified": "Verified in AZ SSO",
  "users.modal.notFound": "Not found in AZ SSO",
  "users.modal.notFoundDesc":
    "This K-Account does not yet exist in AZ SSO. You can still import it; the user will be activated upon their first SSO login.",
  "users.modal.role": "Role",
  "users.modal.role.staff": "Staff",
  "users.modal.role.staffDesc": "Ask Q&A access only",
  "users.modal.role.cra": "CRA",
  "users.modal.role.csm": "CSM",
  "users.modal.role.csmDesc": "Ask Q&A + MVR report access",
  "users.modal.role.craDesc": "Ask Q&A + MVR report access",
  "users.modal.role.admin": "Admin",
  "users.modal.role.adminDesc": "Full access to all features",
  "users.modal.role.manager": "Manager",
  "users.modal.role.managerDesc": "Read-only admin console access",
  "users.modal.role.auditor": "Auditor",
  "users.modal.role.auditorDesc": "Read-only admin console access",
  "users.modal.studyAccess": "Study",
  "users.modal.studyAccessRequired": "*",
  "users.modal.studyHint": "Press Enter or , to add codes. You can paste multiple at once.",
  "users.modal.platformStudies": "Platform Studies",
  "users.modal.searchStudy": "Search or enter study code...",
  "users.modal.addMore": "Add more...",
  "users.modal.allAdded": "All platform studies added",
  "users.modal.typeToSearch": "Type to search or enter custom code",
  "users.modal.clearAll": "Clear All",
  "users.modal.status": "Status",
  "users.modal.statusActive": "Active",
  "users.modal.importHint":
    "User will be imported with Active status. You can edit permissions anytime.",
  "users.modal.cancel": "Cancel",
  "users.modal.import": "Import & Activate",
  "users.modal.studyError": "CRA role requires at least one study code.",
  "users.modal.kAccountError": "Please enter a K-Account",
  "users.modal.exists": "This user already exists in the system",
  "users.form.title": "Assign Permissions",
  "users.form.subtitle": "Manage this user's roles and study permissions",
  "users.form.back": "Back to User & Permission",
  "users.form.userInfo": "User Info",
  "users.form.readOnly": "(read-only)",
  "users.form.accountStatus": "Account Status",
  "users.form.canLogin": "Can log in",
  "users.form.cannotLogin": "Cannot log in",
  "users.form.roleTitle": "Role",
  "users.form.roleDesc": "Select one or more roles for this user",
  "users.form.studyTitle": "Study",
  "users.form.studyDesc":
    "Enter study codes and press Enter or , to add. You can paste multiple at once.",
  "users.form.siteTitle": "Site Access",
  "users.form.siteDesc":
    "Select sites this Staff user can access. Sites are sourced from Ask Source management.",
  "users.form.save": "Save Permissions",
  "users.toast.updated": "User updated successfully",
  "users.toast.created": "User created successfully",
  "users.toast.added": "User added successfully",
  "users.toast.saved": "User saved successfully",
  "users.toast.deleted": "User deleted successfully",
  "users.toast.imported": "Imported and activated",
  "users.toast.disabled": "Disabled — Ask access only",
  "users.toast.reEnabled": "Re-enabled",

  // ─── Recommended Questions ────────────────────────────────────────────────
  "rec.title": "Recommended Questions",
  "rec.subtitle":
    "Manage quick-access questions shown to users. Top 6 by popularity are displayed automatically.",
  "rec.newQuestion": "New Question",
  "rec.statTotal": "Total",
  "rec.statActive": "Active",
  "rec.statPinned": "Pinned",
  "rec.statAutoCaptured": "Auto-captured",
  "rec.statTotalClicks": "Total Clicks",
  "rec.statTotalQueries": "Total Queries",
  "rec.filterStatus": "Status:",
  "rec.filterSource": "Source:",
  "rec.filterTopic": "Topic:",
  "rec.sortLabel": "Sort:",
  "rec.sortCombined": "Combined",
  "rec.sortClicks": "Clicks",
  "rec.sortQueries": "Queries",
  "rec.searchPlaceholder": "Search questions...",
  "rec.autoCaptured": "Auto-captured",
  "rec.simpleSubtitle": "Manage recommended questions shown to users — up to 6 can be enabled",
  "rec.slotCount": "{{count}}/6 configured",
  "rec.slotsTitle": "Question Slots",
  "rec.slotsHint": "Displayed in order — users will see these 6 questions",
  "rec.emptySlot": "Empty slot — hover to add",
  "rec.addQuestion": "Add Question",
  "rec.deleteConfirm": "Confirm delete?",
  "rec.noQuestions": "No recommended questions configured",
  "rec.addFirstQuestion": "Add your first question",
  "rec.bottomHint": "Hover over a row to edit or delete",
  "rec.enabledSection": "Enabled Questions",
  "rec.disabledSection": "Disabled Questions",
  "rec.enabledCount": "{{count}}/6 Enabled",
  "rec.dragToReorder": "Drag to reorder",
  "rec.dragHandle": "Drag to reorder",
  "rec.enable": "Enable",
  "rec.disable": "Disable",
  "rec.enabledHint":
    "Questions higher in the list appear first in the frontend — drag the handle to reorder",
  "rec.disableConfirm": "Confirm disable?",
  "rec.maxEnabledHint": "Maximum reached — disable one question before enabling another",
  "rec.noEnabledQuestions": "No enabled questions yet",
  "rec.noDisabledQuestions": "All questions are enabled",
  "rec.operationFailed": "Operation failed, please try again",

  // ─── Question Table ───────────────────────────────────────────────────────
  "table.source": "Source",
  "table.question": "Question",
  "table.topic": "Topic",
  "table.buttonClicks": "Button Clicks",
  "table.searchQueries": "Search Queries",
  "table.combinedScore": "Combined Score",
  "table.pin": "Pin",
  "table.pinTitle": "Pin to Top 6",
  "table.unpinTitle": "Unpin",
  "table.edit": "Edit",
  "table.totalCount": "Total {{count}} questions",
  "table.autoNote": "Auto = high-frequency questions captured from user input",
  "table.pinnedNote": "Pinned questions are not affected by popularity ranking",
  "table.noResults": "No matching questions found",

  // ─── Recommendation Config ────────────────────────────────────────────────
  "recConfig.title": "Recommendation Settings",
  "recConfig.autoUpdateOn": "Auto-update On",
  "recConfig.pinnedCount": "{{count}} pinned",
  "recConfig.autoUpdateTop6": "Auto-update Top 6",
  "recConfig.autoUpdateDesc":
    "System auto-promotes the hottest questions to Top 6, refreshed daily",
  "recConfig.autoUpdateOffDesc": "Disabled: only pinned questions set by admin will be shown",
  "recConfig.rankingMetric": "Ranking Metric",
  "recConfig.metricCombined": "Combined Score",
  "recConfig.metricCombinedDesc": "clicks + queries, most comprehensive",
  "recConfig.metricClicks": "Button Clicks",
  "recConfig.metricClicksDesc": "counts recommendation button clicks only",
  "recConfig.metricQueries": "Search Queries",
  "recConfig.metricQueriesDesc": "counts user-typed queries only",
  "recConfig.personalizationTrigger": "Personalization Trigger",
  "recConfig.personalizationTriggerDesc":
    "How many interactions before switching to personalized recommendations",
  "recConfig.personalizationTimes": "{{count}} times",
  "recConfig.pinnedNote":
    "{{count}} question(s) pinned — always in Top 6, unaffected by popularity",
  "recConfig.autoCapturedNote":
    "{{count}} high-frequency question(s) auto-captured from user input",
  "recConfig.newUsersNote":
    "New users see global Top 6; after {{count}} interactions, personalized recommendations activate",

  // ─── Personalization Config ───────────────────────────────────────────────
  "personConfig.title": "Personalization Rules",
  "personConfig.activatesAfter": "Activates after {{count}} interactions",
  "personConfig.algorithmFlow": "Algorithm Flow",
  "personConfig.step1Title": "Track User Behavior",
  "personConfig.step1a": "Which recommended questions were clicked",
  "personConfig.step1b": "What keywords were typed in the search box",
  "personConfig.step1c": "Which topic answers were viewed",
  "personConfig.step2Title": "Analyze Topic Preference",
  "personConfig.step2a": "Count interactions per topic",
  "personConfig.step2b_on": "Recent {{count}}-day behavior weighted ×2",
  "personConfig.step2b_off": "All historical behavior weighted equally",
  "personConfig.step2c": "Generate user topic preference score",
  "personConfig.step3Title": "Personalized Ranking",
  "personConfig.step3a": "Pick {{mixRatio}} top-scored questions from preferred topics",
  "personConfig.step3b": "Fill {{globalCount}} slots with global trending questions",
  "personConfig.step3c": "Pinned questions are always kept",
  "personConfig.step4Title": "Display to User",
  "personConfig.step4a": "Replaces the global default Top 6",
  "personConfig.step4b": "Calculated in real-time on each page open",
  "personConfig.step4c": "Preference model continuously optimized",
  "personConfig.ruleConfig": "Rule Configuration",
  "personConfig.dataSource": "Preference Data Source",
  "personConfig.dataSourceDesc": "Which behavior data to use for determining user topic preference",
  "personConfig.dsCombined": "Combined (Recommended)",
  "personConfig.dsCombinedDesc": "Clicks + queries",
  "personConfig.dsClicks": "Button Clicks",
  "personConfig.dsClicksDesc": "Clicks on recommended questions only",
  "personConfig.dsQueries": "Search Queries",
  "personConfig.dsQueriesDesc": "User-typed queries only",
  "personConfig.recency": "Recency Weighting",
  "personConfig.recencyOnDesc": "Behavior in last {{count}} days is weighted 2× vs older records",
  "personConfig.recencyOffDesc": "All historical behavior weighted equally",
  "personConfig.mixRatio": "Personalized / Global Mix",
  "personConfig.mixRatioDesc":
    "Out of 6 recommendations, how many come from user preference topics",
  "personConfig.mixPersonalized": "{{count}} personalized",
  "personConfig.mixGlobal": "{{count}} global trending",
  "personConfig.simulation": "Simulation — What different user types will see",
  "personConfig.userWillSee": "This user will see:",
  "personConfig.plusGlobal": "+ {{count}} global trending",

  // ─── Question Preview ─────────────────────────────────────────────────────
  "preview.title": "Current Default Display — visible to all new users",
  "preview.rankedBy": "Ranked by:",
  "preview.autoRefreshed": "Auto-refreshed daily",
  "preview.autoUpdateDisabled": "Auto-update disabled",
  "preview.livePreview": "Live Preview",
  "preview.noActive": "No active recommended questions",
  "preview.pinnedNote": "Pin icon = pinned by admin, not affected by popularity",
  "preview.scoreNote": "Number = {{metric}} (higher ranks first)",
  "preview.personalizationNote":
    "After {{count}} interactions, personalized recommendations activate",
  "preview.metricCombined": "Combined Score",
  "preview.metricClicks": "Button Clicks",
  "preview.metricQueries": "Search Queries",

  // ─── Edit Question ────────────────────────────────────────────────────────
  "editQ.titleNew": "New Question",
  "editQ.titleEdit": "Edit Question",
  "editQ.subtitleNew": "Add a new recommended quick-access question",
  "editQ.subtitleEdit": "Question ID:",
  "editQ.questionContent": "Question Content",
  "editQ.questionPlaceholder":
    "Enter a recommended question, e.g.: How do I submit a travel reimbursement request?",
  "editQ.questionHint": "Use a question format, keep it under 50 characters for easy scanning",
  "editQ.topicCategory": "Topic Category",
  "editQ.topicDesc":
    "Select the topic(s) for this question. Used for personalized recommendations.",
  "editQ.selectedTopics": "Selected:",
  "editQ.priority": "Priority",
  "editQ.priorityDesc":
    "Higher number = higher priority in the user's Top 6 recommendations (1–10)",
  "editQ.low14": "Low 1–4",
  "editQ.mid57": "Mid 5–7",
  "editQ.high810": "High 8–10",
  "editQ.highPriority": "High Priority",
  "editQ.midPriority": "Mid Priority",
  "editQ.lowPriority": "Low Priority",
  "editQ.pinToTop6": "Pin to Top 6",
  "editQ.pinDesc":
    "When enabled, this question always appears in recommendations regardless of popularity ranking",
  "editQ.pinnedNote": "This question is pinned. Admins can unpin it at any time.",
  "editQ.statusLabel": "Status",
  "editQ.activeDesc": "Will appear in the frontend recommendation list",
  "editQ.inactiveDesc": "Temporarily hidden; data is preserved",
  "editQ.createQuestion": "Create Question",
  "editQ.saveChanges": "Save Changes",
  "editQ.savedRedirecting": "Saved successfully, redirecting...",

  // ─── System Settings Nav ──────────────────────────────────────────────────
  "nav.settings": "Source Settings",
  "nav.pathSettings": "General Source",
  "nav.studySource": "Study Source",
  "nav.updateLogs": "Update Logs",
  "nav.userPermissions": "Users & Permissions",

  // ─── Update Logs ──────────────────────────────────────────────────────────
  "updateLogs.title": "Document Update Logs",
  "updateLogs.subtitle":
    "Track document library updates to ensure modules always access the latest documents",
  "updateLogs.syncNow": "Sync Now",
  "updateLogs.syncing": "Syncing...",
  "updateLogs.syncedAt": "Synced at {{time}}",
  "updateLogs.lastSynced": "Last synced at {{time}}",
  "updateLogs.addLog": "Add Log",
  "updateLogs.editLog": "Edit Log",
  "updateLogs.statTotal": "Total Entries",
  "updateLogs.statThisMonth": "This Month",
  "updateLogs.statMVR": "MVR Updates",
  "updateLogs.statGeneral": "General KB Updates",
  "updateLogs.filterModule": "Module",
  "updateLogs.filterType": "Update Type",
  "updateLogs.allModules": "All Modules",
  "updateLogs.allTypes": "All Types",
  "updateLogs.searchPlaceholder": "Search data source, failed file ...",
  "updateLogs.colDate": "Update Date",
  "updateLogs.colDocument": "Document Name",
  "updateLogs.colVersion": "Version",
  "updateLogs.colModule": "Module",
  "updateLogs.colType": "Update Type",
  "updateLogs.colDescription": "Description",
  "updateLogs.colDataSource": "Source Site",
  "updateLogs.colOperator": "Operator",
  "updateLogs.colActions": "Actions",
  "updateLogs.typeAdded": "Added",
  "updateLogs.typeModified": "Modified",
  "updateLogs.typeRemoved": "Removed",
  "updateLogs.typeRenamed": "Renamed",
  "updateLogs.noRecords": "No update logs found",
  "updateLogs.formDocName": "Document Name",
  "updateLogs.formDocNamePlaceholder": "Enter document name",
  "updateLogs.formVersion": "Version Number",
  "updateLogs.formVersionPlaceholder": "e.g. v2.1.0",
  "updateLogs.formModule": "Module",
  "updateLogs.formUpdateType": "Update Type",
  "updateLogs.formDate": "Update Date",
  "updateLogs.formDescription": "Update Description",
  "updateLogs.formDescPlaceholder":
    "Describe the changes in detail, e.g. updated Section 4.2 per IRB feedback...",
  "updateLogs.formOperator": "Operator",
  "updateLogs.formOperatorPlaceholder": "Enter operator name",
  "updateLogs.deleteConfirm": "Confirm to delete this log entry?",
  "updateLogs.deleted": "Log entry deleted",
  "updateLogs.saved": "Log saved successfully",
  "updateLogs.totalCount": "Total {{count}} entries",
  "updateLogs.filesInvolved": "Files in this update",
  "updateLogs.fileCount": "{{count}} files",
  "updateLogs.updatedFilesPrefix": ", updated",
  "updateLogs.updatedFilesSuffix": "files",
  "updateLogs.systemAutoSync": "Auto Sync",
  "updateLogs.adminManualSync": "Admin Manual Sync",
  "updateLogs.loading": "Loading ...",
  "updateLogs.loadFailed": "Failed to load sync logs. Please try again later.",
  "updateLogs.syncSummaryChanged":
    "Scanned {{scanned}} files and detected {{changed}} changed files",
  "updateLogs.syncSummaryNoChange": "No file changes detected, scanned {{scanned}} files in total",
  "updateLogs.syncSummaryDetail":
    "Scanned {{scanned}} files: {{added}} added, {{updated}} updated, {{skipped}} skipped, {{deleted}} deleted, {{failed}} failed.",
  "updateLogs.failedDetailsTitle": "{{count}} failed file(s)",
  "updateLogs.unknownFile": "Unknown file",
  "updateLogs.unknownFailureReason": "Unknown failure reason",
  "updateLogs.countScanned": "Scanned",
  "updateLogs.countAdded": "New",
  "updateLogs.countRetried": "Retried",
  "updateLogs.countUpdated": "Modified",
  "updateLogs.countSkipped": "Skipped",
  "updateLogs.countDeleted": "Deleted",
  "updateLogs.countFailed": "Failed",
  "updateLogs.sourceError": "Source error",
  "updateLogs.viewFiles": "View files",
  "updateLogs.hideFiles": "Hide",
  "updateLogs.filesPanelTitle": "{{label}} files",
  "updateLogs.fileCountSuffix": "{{count}} files",
  "updateLogs.viewAllSuccessTitle": "{{label}} · Succeeded files",
  "updateLogs.viewAllFailedTitle": "{{label}} · Failed files",
  "uploadLogs.files": "files",
  "uploadLogs.succeeded": "Succeeded",
  "uploadLogs.failedFiles": "Failed files",
  "uploadLogs.viewAll": "View all",
  "uploadLogs.markTooltip": "Mark as handled",
  "uploadLogs.unmarkTooltip": "Unmark",

  // ─── Login ──────────────────────────────────────────────────────────────
  "login.title": "AstraZeneca OpsMate Platform",
  "login.subtitle": "Sign in to access the OpsMate",
  "login.username": "Username",
  "login.usernamePlaceholder": "Enter your username",
  "login.password": "Password",
  "login.passwordPlaceholder": "Enter your password",
  "login.submit": "Sign In",
  "login.loggingIn": "Signing in...",
  "login.copyright": "All rights reserved.",
  "login.errorRequired": "Please enter both username and password",
  "login.errorFailed": "Invalid username or password",
  "login.orDivider": "OR",
  "login.ssoButton": "Enterprise SSO Login",
  "login.ssoLoading": "Redirecting to SSO...",
  "login.ssoFailed": "SSO login failed. Please try again.",
  "login.ssoError.provider_error": "SSO provider returned an error.",
  "login.ssoError.missing_params": "Missing authorization parameters. Please try signing in again.",
  "login.ssoError.state_expired": "The SSO session is invalid or has expired. Please try again.",
  "login.ssoError.no_id_token": "No identity token was returned. Please try again.",
  "login.ssoError.nonce_mismatch": "SSO security check failed. Please try again.",
  "login.ssoError.no_oid": "The account is missing required identity information.",
  "login.ssoError.no_permission":
    "You do not have permission to sign in. Please contact the administrator.",
  "login.ssoError.account_disabled":
    "This account has been disabled. Please contact the administrator.",
  "login.ssoError.login_failed": "SSO sign-in failed. Please try again.",

  // ─── OpsMate ──────────────────────────────────────────────────────────────
  "opsmate.aiReasoning": "AI Reasoning",
  "opsmate.helpImprove": "Help us improve this answer",
  "opsmate.helpImproveDesc":
    "Please let us know why this answer didn't help you (Select all that apply)",
  "opsmate.otherReason": "Other reason (optional)",
  "opsmate.otherReasonPlaceholder": "Optional—help us better understand your feedback",
  "opsmate.acknowledgeBtn": "I Acknowledge & Continue",
  "opsmate.skip": "Skip",
  "opsmate.submit": "Submit",
  "opsmate.loadingAgreement": "Loading agreement status...",
  "opsmate.termsAccepted": "User Terms of Use accepted.",
  "opsmate.termsAcceptFailed": "Failed to accept terms",
  "opsmate.disclaimer": {
    part1: "AZ OpsMate ",
    part2: "is not GCP validated",
    part3: ", by using AZ OpsMate, you confirm that you have read and understood the ",
    termsOfUse: "Terms of Use",
    part4: ".",
  },
  "opsmate.agreeTerms": "By using this feature, you agree to the",
  "opsmate.termsLink": "Terms of Use",
  "opsmate.pinned": "Pinned.",
  "opsmate.unpinned": "Pin removed.",
  "opsmate.pinFailed": "Failed to pin conversation",
  "opsmate.unpinFailed": "Failed to unpin conversation",
  "opsmate.missingSessionLog": "Missing SessionLogId for current answer, cannot submit feedback",
  "opsmate.dislikeReasonRequired": "Please select at least one reason or enter a custom reason",
  "opsmate.feedbackFailed": "Submit feedback failed",
  "opsmate.feedbackSubmitting": "Submitting feedback...",
  "opsmate.feedbackMarkedUseful": "Marked as useful answer",
  "opsmate.feedbackMarkedNotUseful": "Marked as not useful answer",
  "opsmate.feedbackUpdated": "Feedback updated",
  "opsmate.feedbackCancelledLike": "Like cancelled",
  "opsmate.feedbackRetryLater": "Feedback failed, please try again later",
  "opsmate.translationFailed": "Translation failed",
  "opsmate.dislikeReason1": "Answer is incorrect or has errors",
  "opsmate.dislikeReason2": "Not relevant to my question",
  "opsmate.dislikeReason3": "Information is incomplete or missing key details",
  "opsmate.dislikeReason4": "Content is too vague or not actionable",
  "opsmate.dislikeReason5": "Cited sources are not appropriate",
  "opsmate.dislikeReason6": "Answer took too long to generate",
  "opsmate.regenerate": "Regenerate",

  // ─── OpsMate > Agreement ──────────────────────────────────────────────────
  "opsmate.agreement.title": "Terms of Use for OpsMate",
  "opsmate.agreement.tocTitle": "Terms of Use Contents",

  // ─── OpsMate > ConversationsMenus ─────────────────────────────────────────
  "opsmate.menu.title": "OpsMate",
  "opsmate.menu.rename": "Rename",
  "opsmate.menu.pinToTop": "Pin to Top",
  "opsmate.menu.unpinFromTop": "Unpin to Top",
  "opsmate.menu.delete": "Delete",
  "opsmate.menu.expand": "Expand",
  "opsmate.menu.collapse": "Collapse",
  "opsmate.menu.today": "Today",
  "opsmate.menu.yesterday": "Yesterday",
  "opsmate.menu.last7Days": "Last 7 Days",
  "opsmate.menu.last30Days": "Last 30 Days",
  "opsmate.menu.last1Month": "Last 1 Month",
  "opsmate.menu.last6Months": "Last 6 Months",
  "opsmate.menu.older": "Older",
  "opsmate.menu.pinnedGroup": "Pinned",
  "opsmate.menu.deleteTitle": "Delete",
  "opsmate.menu.deleteDesc": "Confirm to delete it?",
  "opsmate.menu.confirm": "Confirm",
  "opsmate.menu.cancel": "Cancel",
  "opsmate.menu.deleted": "Deleted.",
  "opsmate.menu.deleteFailed": "Failed to delete chat",
  "opsmate.menu.renameFailed": "Failed to rename conversation",
  "opsmate.menu.searchPlaceholder": "Search Chat...",
  "opsmate.menu.noData": "No Data Available",
  "opsmate.menu.reachedBottom": "No more results",

  // ─── OpsMate > CustomerSuggestion ─────────────────────────────────────────
  "opsmate.suggestion.q1": "How do I submit travel reimbursement ?",
  "opsmate.suggestion.q2": "What expenses are reimbursable?",
  "opsmate.suggestion.q3": "Hotel booking policy for business trips",
  "opsmate.suggestion.q4": "IT equipment request process",
  "opsmate.suggestion.q5": "Overtime and leave policy",
  "opsmate.suggestion.q6": "What is the registration process for e ... courses?",
  "opsmate.suggestion.inputPlaceholder": "Ask a follow-up question...",
  "opsmate.suggestion.onlySelectedSources": "Ask selected docs only",
  "opsmate.suggestion.stopped": "Generation stopped.",
  "opsmate.suggestion.questionTooLong": "Your question cannot exceed {{max}} characters.",
  "opsmate.suggestion.buildingReferences": "Building References ...",
  "opsmate.suggestion.sendFailed": "Failed to send your question. Please try again.",
  "opsmate.suggestion.sendFailedContent":
    "Sorry, failed to send your question. Please try again later.",
  "opsmate.suggestion.greeting": "Hello {{name}}, how can I help you today?",
  "opsmate.suggestion.inputTooltip": "Please input your question",
  "opsmate.suggestion.emptySelectedSourcesTooltip":
    "Please select at least one source from the Sources panel",
  "opsmate.suggestion.onlySelectedSourcesTooltip":
    "When enabled, AI only searches within the docs you manually check in the Sources panel.",
  "opsmate.suggestion.stopGenerating": "Stop generating",
  "opsmate.scopeSelector.generalDocs": "General Docs",
  "opsmate.scopeSelector.studySource": "Study Docs",
  "opsmate.scopeSelector.personalDocs": "Personal Docs",
  "opsmate.scopeSelector.allTypes": "All Types",
  "opsmate.scopeSelector.allStudies": "All Studies",
  "opsmate.scopeSelector.allStudySources": "All Study Sources",

  // ─── OpsMate > Progress (reasoning panel) ───────────────────────────────
  "opsmate.progress.headerThinkingWithSteps": "Thinking · {{count}} step(s) so far",
  "opsmate.progress.headerThinking": "Thinking…",
  "opsmate.progress.headerCompleted": "Completed thinking steps",
  "opsmate.progress.analyzing": "Analyzing your question, please wait…",
  "opsmate.progress.moreDocuments": "… {{count}} documents in total",
  "opsmate.progress.unknownDoc": "Unknown document",
  "opsmate.progress.queryJoiner": ", ",
  "opsmate.progress.partSeparator": ", ",
  "opsmate.progress.duration.ms": "{{n}} ms",
  "opsmate.progress.duration.s": "{{n}} s",
  "opsmate.progress.boolean.yes": "Yes",
  "opsmate.progress.boolean.no": "No",
  "opsmate.progress.reasoning.failed": "AI reasoning failed",
  "opsmate.progress.reasoning.thinking": "AI is thinking",
  "opsmate.progress.reasoning.section.thinking": "Thinking process",
  "opsmate.progress.reasoning.section.query": "Retrieval question",
  "opsmate.progress.reasoning.section.toRequest": "Request more information",
  "opsmate.progress.reasoning.section.retrievalDecision": "Continue retrieval",
  "opsmate.progress.reasoning.section.rationale": "Reasoning basis",
  "opsmate.progress.reasoning.section.answer": "Draft answer",
  "opsmate.progress.reasoning.section.default": "{{label}}",
  "opsmate.progress.planner.decision.title": "Deciding whether retrieval is needed",
  "opsmate.progress.planner.decision.need": "Decision: more retrieval needed",
  "opsmate.progress.planner.decision.noNeed":
    "Decision: current information is sufficient, no extra retrieval needed",
  "opsmate.progress.planner.decision.done": "Retrieval decision completed",
  "opsmate.progress.planner.queryProposal.titleMulti": "Generated multiple retrieval queries",
  "opsmate.progress.planner.queryProposal.titleSingle": "Generated a retrieval query",
  "opsmate.progress.planner.queryProposal.keywords": "Query keywords: {{queries}}",
  "opsmate.progress.retrieval.started.title": "Retrieving information",
  "opsmate.progress.retrieval.started.query": "Query keyword: {{query}}",
  "opsmate.progress.retrieval.completed.title": "Retrieval completed",
  "opsmate.progress.retrieval.failed.title": "Retrieval error",
  "opsmate.progress.retrieval.failed.desc": "Please retry later or try different keywords",
  "opsmate.progress.retrieval.foundNew": "Found {{count}} new relevant item(s)",
  "opsmate.progress.retrieval.foundTotal": "Retrieved {{count}} item(s)",
  "opsmate.progress.retrieval.duration": "took {{duration}}",
  "opsmate.progress.retrieval.results.title": "Hit {{count}} relevant segment(s)",
  "opsmate.progress.retrieval.results.titleEmpty": "Retrieval results received",
  "opsmate.progress.retrieval.results.fromDocs": "From {{count}} document(s)",
  "opsmate.progress.fallback.failed": "Something went wrong during processing",
  "opsmate.progress.fallback.tool": "Executing tool call",
  "opsmate.progress.fallback.reasoningStep": "AI reasoning step",
  "opsmate.progress.trace.tool.load_skill": "Loading skill",
  "opsmate.progress.trace.tool.kb_search": "Knowledge base search",
  "opsmate.progress.trace.tool.kb_find_documents": "Finding documents",
  "opsmate.progress.trace.tool.kb_read": "Reading document",
  "opsmate.progress.trace.tool.kb_get_outline": "Reading document outline",
  "opsmate.progress.trace.tool.default": "Tool calling",
  "opsmate.progress.trace.call.title": "Tool calling: {{tool}}",
  "opsmate.progress.trace.result.title": "{{tool}} completed",
  "opsmate.progress.trace.result.count": "Hit {{count}} result(s)",
  "opsmate.progress.trace.result.empty": "No results returned this time",
  "opsmate.progress.trace.result.emptyDocs": "No relevant documents found",
  "opsmate.progress.trace.query": "Query: {{query}}",
  "opsmate.progress.trace.assistant": "AI interim analysis",
  "opsmate.progress.trace.loadSkill.call": "Loading skill",
  "opsmate.progress.trace.loadSkill.done": "Skill ready",
  "opsmate.progress.trace.skill.knowledgeQa": "Knowledge Q&A",
  "opsmate.progress.trace.skill.replan": "Re-planning retrieval",
  "opsmate.progress.trace.skill.groundedAnswer": "Grounded answering",
  "opsmate.progress.trace.arg.query": "Query",
  "opsmate.progress.trace.arg.keyword": "Keyword",
  "opsmate.progress.trace.arg.topK": "Top results",
  "opsmate.progress.trace.arg.documentIds": "Scoped docs",
  "opsmate.progress.trace.arg.documentId": "Document",
  "opsmate.progress.trace.arg.sectionId": "Section",
  "opsmate.progress.trace.arg.skillName": "Skill",
  "opsmate.progress.trace.arg.default": "{{label}}",
  "opsmate.progress.trace.arg.allDocs": "All documents",
  "opsmate.progress.trace.arg.moreItems": " +{{count}} more",
  "opsmate.progress.trace.match.filename": "Filename match",
  "opsmate.progress.trace.match.content": "Content match",
  "opsmate.progress.status.loadingConfig": "Loading assistant configuration…",
  "opsmate.progress.status.assemblingTools": "Preparing tools and skills…",
  "opsmate.progress.status.callingLlm": "Calling the model…",
  "opsmate.progress.status.runningTool": "Tool calling: {{tool}}…",
  "opsmate.progress.status.runningWorkflow": "Running workflow: {{workflow}}…",

  // ─── OpsMate > DocumentList ───────────────────────────────────────────────
  "opsmate.docs.sources": "Sources",
  "opsmate.docs.expandSources": "Expand Sources",
  "opsmate.docs.collapseSources": "Collapse Sources",
  "opsmate.docs.selectAll": "Select All",
  "opsmate.docs.no_data": "No data available",
  "opsmate.docs.emptyDesc":
    "No sources available for the current scope. Try adding sources or selecting additional knowledge bases.",
  "opsmate.docs.basedOnDocs": "Answer generated based on selected documents.",
  "opsmate.docs.sourceTips": "Last updated at {{time}}",
  "opsmate.docs.addSourcesTitle": "Add Sources",
  "opsmate.docs.searchPlaceholder": "Search Documents...",
  "opsmate.docs.searchingDocs": "Searching documents...",
  "opsmate.docs.noData": "No Data Available",
  "opsmate.docs.allLoaded": "All documents loaded",
  "opsmate.docs.addSources": "Add Sources",
  "opsmate.docs.cancel": "Cancel",
  "opsmate.docs.confirm": "Confirm",
  "opsmate.docs.latestUpdate": "Latest Update {{date}}",
  "opsmate.docs.selected": "Selected",
  "opsmate.docs.downloadUnavailable": "The download link is temporarily unavailable.",
  "opsmate.docs.loadFailed": "Failed to load documents.",
  "opsmate.docs.filterSelectedCount": "{{count}} selected",
  "opsmate.docs.personalIncluded": "Included",
  "opsmate.docs.personalExcluded": "Excluded",
  "opsmate.docs.loadingMore": "Loading more...",
  "opsmate.docs.openTeamsChannel": "Open in Teams Channel",
  "opsmate.docs.openSharePointSite": "Open in SharePoint",

  // ─── OpsMate > Terms of Use Page ──────────────────────────────────────────
  "opsmate.termsOfUse.pageTitle": "AZ OpsMate - Terms of Use",
  "pathSettings.title": "General Source Settings",
  "pathSettings.subtitle": "Configure SharePoint source paths for the Ask module knowledge base",
  "studySource.title": "Study Source Settings",
  "studySource.subtitle":
    "Manage the document sources of each study, connected to Microsoft Teams Channel / SharePoint Site and synced hourly",
  "pathSettings.globalKeywords.title": "Global Excluded Keywords",
  "pathSettings.globalKeywords.tooltip":
    "These keywords apply to ALL sites and paths. Any file or folder whose name contains one of these keywords will be skipped during sync and indexing. Supports simple substring matching.",
  "pathSettings.globalKeywords.empty": "Keywords not configured yet.",
  "pathSettings.globalKeywords.edit": "Edit",
  "pathSettings.globalKeywords.add": "Add",
  "pathSettings.globalKeywords.cancel": "Cancel",
  "pathSettings.globalKeywords.save": "Save",
  "pathSettings.globalKeywords.loading": "Loading keywords...",
  "pathSettings.globalKeywords.retry": "Retry",
  "pathSettings.globalKeywords.loadFailed": "Failed to load global excluded keywords.",
  "pathSettings.globalKeywords.saveFailed":
    "Failed to save global excluded keywords. Please try again.",
  "pathSettings.globalKeywords.placeholder": "e.g. temp, draft, backup",
  "pathSettings.globalKeywords.inputLabel": "Keywords to add",
  "pathSettings.globalKeywords.remove": "Remove {{keyword}}",
  "pathSettings.addPath": "Add Path",
  "pathSettings.banner.title": "Authorization prerequisite for adding a new Site",
  "pathSettings.banner.desc":
    "Before adding a new SharePoint site path, ensure AZ IT has authorized the system\u2019s client_id for that site. Unauthorized sites will fail to be indexed and files will not be accessible. Contact AZ IT to complete the authorization before proceeding.",
  "pathSettings.prereq.modalTitle": "Add General Source",
  "pathSettings.prereq.modalSubtitle": "Please confirm the following before proceeding",
  "pathSettings.prereq.warningTitle": "AZ Authorization Required",
  "pathSettings.prereq.warningDesc":
    "The SharePoint site you are adding must have its client_id authorized by AZ IT. Without this authorization, files in the path cannot be indexed or accessed by the system.",
  "pathSettings.prereq.checkPermission":
    "You have the Site Owner or Contributor permission on the target site",
  "pathSettings.prereq.checkboxLabel":
    "I confirm the AZ IT has authorized the client_id for this site",
  "pathSettings.prereq.cancel": "Cancel",
  "pathSettings.prereq.confirm": "Continue \u2014 Add Path",
  "pathSettings.save": "Save",
  "pathSettings.cancel": "Cancel",
  "pathSettings.add": "Add",
  "pathSettings.loading": "Loading ...",
  "pathSettings.loadFailed": "Failed to load paths. Please try again.",
  "pathSettings.saveFailed":
    "Failed to save path. Please check whether the included path already exists.",
  "pathSettings.deleteFailed": "Failed to delete path. Please try again.",
  "pathSettings.createSuccess": "Source created successfully",
  "pathSettings.updateSuccess": "Source updated successfully",
  "pathSettings.deleteSuccess": "Source removed successfully",
  "pathSettings.emptyPaths": 'No paths configured. Click "Add Path" to get started.',
  "pathSettings.placeholder": "https://astrazeneca.sharepoint.com/sites/...",
  "pathSettings.editTitle": "Edit General Source",
  "pathSettings.sourceNotFound": "General Source not found.",
  "pathSettings.sourceSite": "Source Site",
  "pathSettings.sourceDrive": "Source Drive",
  "pathSettings.sourcePath": "Source Folder Path",
  "pathSettings.includedPaths": "Included Path",
  "pathSettings.excludedPaths": "Excluded Path",
  "pathSettings.docCategories": "Doc Categories",
  "pathSettings.docTags": "Doc Tags",
  "pathSettings.operation": "Operation",
  "pathSettings.sourceType": "Type",
  "pathSettings.sourceTypeTooltip":
    "Document category from Document Category Management. Primarily used to control user access permissions — users can only view sources of categories they have been granted access to. Manage categories in Admin → Source Settings → Document Categories.",
  "sourceForm.loadingMeta": "Loading document metadata from Admin Mgmt...",
  "sourceForm.docCategories": "Doc Categories",
  "sourceForm.docCategoriesTooltip":
    "Categories used by the AI to analyze and classify documents under this path. During AI document analysis, files are automatically classified into the selected categories based on their content. Manage categories in Admin → Source Settings → Document Categories.",
  "sourceForm.docCategoriesPlaceholder": "Select categories from Admin Mgmt...",
  "sourceForm.docTags": "Doc Tags",
  "sourceForm.docTagsTooltip":
    'Select tags from Admin "Document Tag Management" and define tag values. During document analysis, files under this path will be tagged accordingly.',
  "sourceForm.docTagsSelectTag": "Select tag...",
  "sourceForm.docTagsSelectValues": "Select {{tag}}(s) or type value...",
  "sourceForm.docTagsTagValues": "Tag values...",
  "sourceForm.docTagsRemoveGroup": "Remove this tag group",
  "sourceForm.docTagsAddTag": "Add tag",
  "sourceForm.docTagsEmpty":
    "No tags defined yet. Please go to Admin → Source Settings → Document Tags to create them first.",
  "sourceForm.sourceTypePlaceholder": "Select a document category...",
  "sourceForm.sourceTypeEmpty":
    "No categories defined yet. Please go to Admin → Source Settings → Document Categories to create them first.",
  "sourceForm.remark": "Description",
  "sourceForm.remarkPlaceholder": "Describe this source for users...",
  "sourceForm.remarkHint": "This description is shown on the Ask Sources page",
  "sourceForm.agentTips": "Agent Tips",
  "sourceForm.agentTipsTooltip":
    "Instructions for the AI agent to better understand this source. These tips help guide how the AI uses and interprets this source in responses.",
  "sourceForm.agentTipsPlaceholder":
    "e.g. Prioritize current documents over archived ones. For compliance queries, always cite the specific regulation document.",
  "sourceForm.agentTipsHint":
    "These tips are used by the AI agent to guide how it interprets and uses this source",
  "sourceForm.region": "Region",
  "sourceForm.regionTooltip":
    "Restrict this source to specific geographic regions. Users outside the selected regions will not see this source in knowledge base results.",
  "sourceForm.region.mainland": "Mainland China",
  "sourceForm.region.hongKong": "Hong Kong",
  "sourceForm.userScope": "User Scope",
  "sourceForm.userScopeTooltip": "Controls this Source's visibility to external users.",
  "sourceForm.userScope.internalExternal": "Internal & External",
  "sourceForm.userScope.internalOnly": "AZ Internal Only",
  "pathSettings.sourceSitePlaceholder": "TSM937",
  "pathSettings.allDrives": "All drives",
  "pathSettings.sourceDrivePlaceholder": "Documents",
  "pathSettings.sourceDriveHint":
    "The default document drive is <Documents>. You could leave empty for all drives in the site. Update here if the drive is renamed.",
  "pathSettings.sourcePathPlaceholder": "/ or /subfolder/",
  "pathSettings.includedPathsPlaceholder": "/Archive/HR-Library",
  "pathSettings.excludedPathsPlaceholder": "/Archive/HR-Library/legacy",
  "pathSettings.addPathField": "Add",
  "pathSettings.removePathField": "Remove",
  "pathSettings.includedPathsHint":
    "Folder paths or file names to include in the knowledge base index. Enter / explicitly to sync the entire scope. Each path maps to a SharePoint drive directory or file. Exact path matching supports a single file like /folder/report.docx or a full subfolder like /Archive/HR-Library/legacy. Use + to add a separate field for each additional path.",
  "pathSettings.excludedPathsHint":
    "Files or subfolders to exclude within the Include Paths above. Exclusions apply to all Include Paths under this site and drive. Exact path matching supports a single file or a full subfolder. Use + to add a separate field for each additional path.",
  "pathSettings.deleteConfirmTitle": "Remove this path?",
  "pathSettings.deleteConfirmDesc": "This action cannot be undone.",
  "pathSettings.delete": "Remove",
  "pathSettings.pathMustStartWithSlash": "Path must start with /",
  "pathSettings.includedPathRequired": "Included Path is required. Enter / to sync all content.",
  "pathSettings.exactPathConflict":
    '"{{path}}" is already in Include Paths and cannot be excluded at the same time.',
  "pathSettings.excludedAncestorConflict":
    'Exclude path "{{excludedPath}}" completely covers Include path "{{includedPath}}", so that Include path will never take effect. Remove one of them.',
  "pathSettings.searchPlaceholder": "Search by site or path...",
  "pathSettings.globalKeywords.subtitle":
    "Keywords listed here will be excluded globally from path ingestion.",
  "pathSettings.globalKeywords.addBtn": "Add",
  "pathSettings.filter.allDocCategories": "All Doc Categories",
  "pathSettings.filter.allDocTags": "All Doc Tags",
  "pathSettings.filter.allSourceTypes": "All Source Types",
  "pathSettings.filter.allRegions": "All Regions",
  "pathSettings.filter.mainland": "Mainland",
  "pathSettings.filter.hongkong": "Hong Kong",
  "pathSettings.filter.allScopes": "All Scopes",
  "pathSettings.filter.resetAll": "Reset All",

  // Admin - Teams Integration
  "teams.title": "MVR Document Sources",
  "teams.subtitle": "Manage Teams channel source configuration for each study",
  "teams.allStudies": "All Studies",
  "teams.addSource": "Add Source",
  "teams.studyName": "Study Name",
  "teams.folders": "Folders",
  "teams.noSources": "No matching sources",
  "teams.noSourcesHint": "Try adjusting your filters",
  "teams.authRequired": "AZ IT authorization required",
  "teams.studyRequired": "Study",
  "teams.sourceUrl": "Source URL",
  "teams.folderPaths": "Sync Folder Paths",
  "teams.addPath": "Add Path",
  "teams.folderPathPlaceholder": "Enter folder path...",
  "teams.validatePaths": "Validate Paths",
  "teams.validatingPaths": "Validating paths...",
  "teams.validCount": "valid",
  "teams.invalidCount": "invalid",
  "teams.cancel": "Cancel",
  "teams.configuredPaths": "Configured Paths",
  "teams.status.succeeded": "Succeeded",
  "teams.status.running": "Running",
  "teams.status.queued": "Queued",
  "teams.status.failed": "Failed",
  "teams.status.pending": "Pending",
  "teams.copied": "Copied",
  "teams.copyUrl": "Copy URL",
  "teams.close": "Close",
  "teams.viewUrl": "View Full URL",
  "teams.synced": "Synced",
  "teams.syncing": "Syncing",
  "teams.error": "Error",
  "teams.pending": "Pending",
  "teams.healthy": "Healthy",
  "teams.warning": "Warning",
  "teams.hotDocs": "Hot Docs",
  "teams.totalHotDocs": "Total Hot Docs",
  "teams.linkedStudies": "Linked Studies",
  "teams.lastSyncDate": "Last Sync Date",
  "teams.lastSynced": "Last Synced",
  "teams.siteSyncStatus": "Site Sync Status",
  "teams.indexedDocs": "Indexed Documents",
  "teams.removePath": "Remove Path",
  "teams.editSource": "Edit Source",
  "teams.editSourceTitle": "Edit Source",
  "teams.deleteSource": "Delete Source",
  "teams.deleteConfirmTitle": "Confirm Delete",
  "teams.deleteConfirmDesc":
    "This source and all configured paths will be permanently removed and cannot be recovered.",
  "teams.deleteConfirmCancel": "Cancel",
  "teams.deleteConfirmDelete": "Delete",
  "teams.sourceDeleted": "Source deleted",
  "teams.excludedSubfolders": "Excluded Subfolders",

  // Admin - Health Monitor
  "healthMonitor.title": "Health Monitor",
  "healthMonitor.subtitle": "Monitor Pike-RAG service APIs health status",
  "healthMonitor.status.allHealthy": "All Healthy",
  "healthMonitor.status.degraded": "Degraded",
  "healthMonitor.status.critical": "Critical",
  "healthMonitor.runAllChecks": "Run All Checks",
  "healthMonitor.runAllChecking": "Checking...",
  "healthMonitor.lastFullCheck": "Last full check",
  "healthMonitor.group.pikeRag": "Pike-RAG Services",
  "healthMonitor.group.opsmate": "OpsMate Internal Services",
  "healthMonitor.group.thirdParty": "Third-party Integrations",
  "healthMonitor.group.azureOpenai": "Azure OpenAI Services",
  "healthMonitor.lastChecked": "Last Checked",
  "healthMonitor.historyRecords": "History",
  "healthMonitor.last24hRecords": "Last 24 Records",
  "healthMonitor.table.noResults": "No health check records found",
  "healthMonitor.table.noResultsHint": "Try adjusting the API filter",
  "healthMonitor.filter.allApis": "All APIs",
  "healthMonitor.timeAgo.justNow": "just now",
  "healthMonitor.timeAgo.minute": "{{count}} minute ago",
  "healthMonitor.timeAgo.minutes": "{{count}} minutes ago",
  "healthMonitor.timeAgo.hour": "{{count}} hour ago",
  "healthMonitor.timeAgo.hours": "{{count}} hours ago",
  "healthMonitor.timeAgo.day": "{{count}} day ago",
  "healthMonitor.timeAgo.days": "{{count}} days ago",
  "healthMonitor.col.checkTime": "Check Time",
  "healthMonitor.col.result": "Result",
  "healthMonitor.col.endpoint": "API Endpoint",
  "healthMonitor.col.method": "Method",
  "healthMonitor.checkSuccess": "Check Passed",
  "healthMonitor.healthy": "Healthy",
  "healthMonitor.warning": "Warning",
  "healthMonitor.critical": "Critical",
  "healthMonitor.col.status": "Status",
  "healthMonitor.col.name": "Service",
  "healthMonitor.col.target": "Target",
  "healthMonitor.col.responseTime": "Response Time",
  "healthMonitor.col.lastChecked": "Last Checked",
  "healthMonitor.col.action": "Action",
  "healthMonitor.item.healthy": "Healthy",
  "healthMonitor.item.warning": "Warning",
  "healthMonitor.item.critical": "Critical",
  "healthMonitor.checking": "Checking",
  "healthMonitor.consecutiveFails": "consecutive fails",
  "healthMonitor.viewError": "View error",
  "healthMonitor.resultDetail.title": "Check Result",
  "healthMonitor.hideError": "Hide error",
  "healthMonitor.lastError": "Last error",
  "healthMonitor.checkNow": "Check Now",
  "healthMonitor.alertConfig.title": "Alert Configuration",
  "healthMonitor.alertConfig.emailLabel": "Alert Email",
  "healthMonitor.alertConfig.ruleLabel": "Trigger Rule",
  "healthMonitor.alertConfig.ruleDesc":
    "Auto-send alert email after 3 consecutive failures or response timeout exceeds 5 seconds",
  "healthMonitor.alertConfig.cronLabel": "Scheduled Check",
  "healthMonitor.alertConfig.cronDesc": "Auto-check every 1 hour",
  "healthMonitor.recipients.title": "Email Recipients",
  "healthMonitor.recipients.addPlaceholder": "Enter email and press Enter",
  "healthMonitor.recipients.empty":
    "No recipients configured — no notifications will be sent on API failures",
  "healthMonitor.recipients.invalidEmail": "Please enter a valid email address",
  "healthMonitor.recipients.duplicate": "This email is already in the list",
  "healthMonitor.recipients.manageRecipients": "Manage Email Recipients",
  "healthMonitor.recipients.manageDesc":
    "Add or remove email recipients for alert notifications. Changes take effect immediately.",
  "healthMonitor.recipients.noRecipientsInModal": "No recipients yet. Add one below.",
  "healthMonitor.alertConfig.sectionTitle": "Alert Notification Configuration",
  "healthMonitor.alertConfig.enableLabel": "Enable Email Alerts",
  "healthMonitor.alertConfig.triggerRuleTitle": "Trigger Rule",
  "healthMonitor.alertConfig.triggerRuleDesc":
    "When any API check returns a critical status, the system will automatically send email notifications to all configured recipients",
  "healthMonitor.enabled": "Enabled",
  "healthMonitor.disabled": "Disabled",
  "healthMonitor.interval": "Interval",
  "healthMonitor.intervalMode.minutes": "Min(s)",
  "healthMonitor.intervalMode.hours": "Hour(s)",
  "healthMonitor.intervalMode.days": "Day(s)",
  "healthMonitor.intervalValue": "every {{value}} {{unit}}",
  "healthMonitor.intervalRangeMinutes": "10-60 minutes",
  "healthMonitor.intervalRangeHours": "1-24 hours",
  "healthMonitor.intervalRangeDays": "1-30 days",
  "healthMonitor.editInterval": "Edit",
  "healthMonitor.intervalSettings": "Interval Settings",
  "healthMonitor.intervalPreview": "Every {{value}} {{unit}}",

  // Admin - Security Monitor
  "securityMonitor.subtitle": "Review system anomaly behavior records",
  "securityMonitor.activeAlerts": "Active Alerts",
  "securityMonitor.realTime": "Real-time",
  "securityMonitor.tab.traffic": "Traffic & Quality",
  "securityMonitor.tab.kb": "Knowledge Base Health",
  "securityMonitor.tab.injection": "Injection & Abuse",
  "securityMonitor.alert.critical": "Critical",
  "securityMonitor.alert.warning": "Warning",
  "securityMonitor.alert.info": "Info",

  // Security Monitor - Traffic
  "securityMonitor.traffic.totalRequests": "Total QA Requests",
  "securityMonitor.traffic.requests5m": "Requests per 5min",
  "securityMonitor.traffic.successRate": "Success Rate",
  "securityMonitor.traffic.failureRate": "Failure Rate",
  "securityMonitor.traffic.avgResponseTime": "Avg Response Time",
  "securityMonitor.traffic.sseDisconnectRate": "SSE Disconnect Rate",
  "securityMonitor.traffic.chartTitle": "QA Traffic Trend (Last 4h, 5min intervals)",
  "securityMonitor.traffic.chartHint": "Click data points for details",
  "securityMonitor.traffic.legend.requests": "Requests",
  "securityMonitor.traffic.legend.p95": "P95 Response",
  "securityMonitor.traffic.tooltip.requests": "Requests",
  "securityMonitor.traffic.tooltip.success": "Success",
  "securityMonitor.traffic.tooltip.failed": "Failed",
  "securityMonitor.traffic.tooltip.avgTime": "Avg Time",
  "securityMonitor.traffic.tooltip.p95": "P95",
  "securityMonitor.traffic.anomalyTitle": "Anomaly User Detection",
  "securityMonitor.traffic.anomalyHint": "Users exceeding QA frequency threshold",
  "securityMonitor.traffic.col.user": "User",
  "securityMonitor.traffic.col.requests5m": "5min Requests",
  "securityMonitor.traffic.col.requests1h": "1h Requests",
  "securityMonitor.traffic.col.avgLen": "Avg Question Length",
  "securityMonitor.traffic.col.longQuestions": "Long Questions",
  "securityMonitor.traffic.col.status": "Status",
  "securityMonitor.traffic.status.critical": "Critical",
  "securityMonitor.traffic.status.warning": "Warning",
  "securityMonitor.traffic.status.normal": "Normal",

  // Security Monitor - KB Health
  "securityMonitor.kb.syncFailed": "Sync Failures",
  "securityMonitor.kb.ragStuck": "RAG Job Backlog",
  "securityMonitor.kb.docSpike": "Doc Count Spike",
  "securityMonitor.kb.docDrop": "Doc Count Drop",
  "securityMonitor.kb.eventTitle": "Knowledge Base Anomaly Events",
  "securityMonitor.kb.eventHint": "Last 24 hours",
  "securityMonitor.kb.col.type": "Event Type",
  "securityMonitor.kb.col.description": "Description",
  "securityMonitor.kb.col.study": "Study",
  "securityMonitor.kb.col.count": "Count",
  "securityMonitor.kb.col.severity": "Severity",
  "securityMonitor.kb.col.time": "Time",
  "securityMonitor.kb.severity.critical": "Critical",
  "securityMonitor.kb.severity.warning": "Warning",
  "securityMonitor.kb.type.syncFailed": "Sync Failed",
  "securityMonitor.kb.type.ragStuck": "RAG Job Stuck",
  "securityMonitor.kb.type.docSpike": "Doc Count Spike",
  "securityMonitor.kb.type.docDrop": "Doc Count Drop",

  // Security Monitor - Injection & Abuse
  "securityMonitor.injection.totalHits": "Total Hits Today",
  "securityMonitor.injection.blocked": "Blocked Requests",
  "securityMonitor.injection.highRiskUsers": "High-Risk Users",
  "securityMonitor.injection.flagged": "Flagged Requests",
  "securityMonitor.injection.alertsTitle": "High-Risk Question Detection",
  "securityMonitor.injection.alertsHint": "Prompt Injection hit details",
  "securityMonitor.injection.col.user": "User",
  "securityMonitor.injection.col.question": "Question",
  "securityMonitor.injection.col.keywords": "Keywords",
  "securityMonitor.injection.col.riskLevel": "Risk Level",
  "securityMonitor.injection.col.action": "Action",
  "securityMonitor.injection.col.time": "Time",
  "securityMonitor.injection.risk.high": "High",
  "securityMonitor.injection.risk.medium": "Medium",
  "securityMonitor.injection.risk.low": "Low",
  "securityMonitor.injection.action.blocked": "Blocked",
  "securityMonitor.injection.action.flagged": "Flagged",
  "securityMonitor.injection.action.passed": "Passed",
  "securityMonitor.injection.usersTitle": "Consecutive Trigger Alert Users",
  "securityMonitor.injection.usersHint": "Auto-alert when threshold exceeded",
  "securityMonitor.injection.col.consecutive": "Consecutive Triggers",
  "securityMonitor.injection.col.total24h": "24h Total",
  "securityMonitor.injection.col.lastTrigger": "Last Trigger",
  "securityMonitor.injection.col.userStatus": "User Status",
  "securityMonitor.injection.status.blocked": "Blocked",
  "securityMonitor.injection.status.warned": "Warned",
  "securityMonitor.injection.status.monitoring": "Monitoring",

  // Admin - Anomaly Behavior Detection
  "anomaly.threshold.frequencyTitle": "Frequency Anomaly",
  "anomaly.threshold.lengthTitle": "Length Anomaly",
  "anomaly.threshold.duplicateTitle": "Duplicate Questions",
  "anomaly.threshold.minutes": "min",
  "anomaly.threshold.times": "times",
  "anomaly.threshold.lengthNote":
    "A single question exceeding {min} characters is considered anomalous (max 2000)",
  "anomaly.threshold.frequencyDesc":
    "A user sending {{count}} requests within {{minutes}} minutes is considered anomalous",
  "anomaly.threshold.duplicateDesc":
    "A user asking the same question {{count}} times within {{minutes}} minutes is considered anomalous",
  "anomaly.behaviorType.frequency": "Frequency",
  "anomaly.behaviorType.length": "Length",
  "anomaly.behaviorType.duplicate": "Duplicate",
  "anomaly.behaviorListTitle": "Anomaly Behavior Records",
  "anomaly.behaviorListHint": "{{count}} anomaly records",
  "anomaly.filter.timeRange": "Time Range",
  "anomaly.filter.last1Hour": "Last 1 Hour",
  "anomaly.filter.last4Hours": "Last 4 Hours",
  "anomaly.filter.last24Hours": "Last 24 Hours",
  "anomaly.filter.last7Days": "Last 7 Days",
  "anomaly.col.behaviorType": "Behavior Type",
  "anomaly.col.user": "User",
  "anomaly.col.questionText": "Trigger Content",
  "anomaly.col.detail": "Anomaly Detail",
  "anomaly.col.time": "Time",
  "anomaly.modal.title": "Edit {name} Threshold",
  "anomaly.relatedMessages": "Related Sessions",
  "anomaly.modal.timeWindow": "Time Window",
  "anomaly.modal.countThreshold": "Count Threshold",
  "anomaly.modal.countThresholdLength": "Long Question Count Threshold",
  "anomaly.modal.charThreshold": "Character Lower Limit",
  "anomaly.modal.charUnit": "chars",
  "anomaly.modal.charHint":
    "Exceeding this character count is considered anomalous (max input 2000 chars)",
  "anomaly.modal.invalidValue": "Time window and count threshold must be greater than 0",
  "anomaly.modal.charRangeError": "Character threshold must be between 100 and 2000",
  "anomaly.modal.desc.duplicate":
    "A user asking the same question {{count}} times within {{minutes}} minutes is considered anomalous",
  "anomaly.modal.desc.frequency":
    "A user sending {{count}} requests within {{minutes}} minutes is considered anomalous",
  "anomaly.detail.frequency": "{{count}} requests within {{minutes}} minutes",
  "anomaly.detail.duplicate": "{{count}} duplicate questions within {{minutes}} minutes",

  // Admin - System Logs
  "systemLogs.title": "System Logs",
  "systemLogs.subtitle":
    "Track user operations, data access, conversation history, and upload logs",
  "systemLogs.subtitle.operation":
    "Records all front-end user and admin operations, including login, logout, questions, source downloads, feedback submissions, and admin actions",
  "systemLogs.subtitle.access":
    "View Source access permissions per user (CKB, GKB, and Study Sources), with toggle between user view and source view",
  "systemLogs.subtitle.model":
    "Browse complete conversation history, including full questions, AI answers, and step-by-step reasoning chains",
  "systemLogs.subtitle.upload":
    "Track document library updates to ensure modules always access the latest documents",
  "systemLogs.tab.operation": "Operation Logs",
  "systemLogs.tab.access": "Data Access",
  "systemLogs.tab.model": "Ask History",
  "systemLogs.tab.upload": "Update Logs",
  "systemLogs.filter.timeRange": "Time Range",
  "systemLogs.filter.opType": "Operation Type",
  "systemLogs.filter.role": "Role",
  "systemLogs.filter.search": "Search user or detail...",
  "systemLogs.filter.apiType": "API Type",
  "systemLogs.filter.status": "Status",
  "systemLogs.filter.viewBy": "View By",
  "systemLogs.filter.byUser": "By User",
  "systemLogs.filter.bySource": "By Source",
  "systemLogs.filter.allOpTypes": "All Operation Types",
  "systemLogs.filter.allRoles": "All Roles",
  "systemLogs.filter.allStatus": "All Status",
  "systemLogs.filter.reset": "Reset",
  "systemLogs.col.time": "Time",
  "systemLogs.col.user": "User",
  "systemLogs.col.role": "Role",
  "systemLogs.col.opType": "Operation",
  "systemLogs.col.detail": "Detail",
  "systemLogs.col.ip": "IP Address",
  "systemLogs.col.status": "Status",
  "systemLogs.col.sources": "Accessible Sources",
  "systemLogs.col.lastAccess": "Last Access",
  "systemLogs.col.accessCount": "Access (30d)",
  "systemLogs.col.sessionId": "Message ID",
  "systemLogs.col.question": "Question",
  "systemLogs.col.tokens": "Tokens",
  "systemLogs.col.responseTime": "Response Time",
  "systemLogs.col.endpoint": "Endpoint",
  "systemLogs.col.method": "Method",
  "systemLogs.col.statusCode": "Status Code",
  "systemLogs.col.triggeredBy": "Triggered By",
  "systemLogs.col.authorizedUsers": "Authorized Users",
  "systemLogs.col.sourceType": "Type",
  "systemLogs.col.sourceName": "Source Name",
  "systemLogs.status.success": "Success",
  "systemLogs.status.failed": "Failed",
  "systemLogs.detail.title": "Log Detail",
  "systemLogs.detail.params": "Operation Parameters",
  "systemLogs.detail.question": "Full Question",
  "systemLogs.detail.answer": "AI Answer",
  "systemLogs.detail.reasoning": "Reasoning Process",
  "systemLogs.detail.requestBody": "Request Body",
  "systemLogs.detail.responseBody": "Response Body",
  "systemLogs.detail.step": "Step",
  "systemLogs.op.login": "Login",
  "systemLogs.op.logout": "Logout",
  "systemLogs.op.submitFeedback": "Submit Feedback",
  "systemLogs.op.translate": "Translate",
  "systemLogs.op.feedback": "Feedback",
  "systemLogs.op.downloadSource": "Download Source",
  "systemLogs.op.uploadPersonnelFiles": "Upload Personnel Files",
  "systemLogs.op.manageUser": "Manage User",
  "systemLogs.op.manageStudy": "Manage Study",
  "systemLogs.op.manageAskSource": "Manage Ask Source",
  "systemLogs.op.manageMvrSource": "Manage MVR Source",
  "systemLogs.op.markFailedFiles": "Mark Failed Files",
  "systemLogs.op.manageRecommendedQuestion": "Manage Recommended Question",
  "systemLogs.op.manageHealthMonitor": "Manage Health Monitor",
  "systemLogs.op.manageSecurityRecords": "Manage Security Records",
  "systemLogs.op.setFeedbackNote": "Set Feedback Note",
  "systemLogs.op.manageSystemSettings": "Manage System Settings",
  "systemLogs.export": "Export",
  "systemLogs.viewDetail": "Detail",
  "systemLogs.noLogs": "No logs found",
  "sidebar.systemLogs": "System Logs",
  "sidebar.healthMonitor": "Health Monitor",
  "sidebar.prd": "PRD Docs",
  "sidebar.securityMonitor": "Security Records",

  // Document Categories
  "docCategories.title": "Document Category Management",
  "docCategories.tooltip":
    "Define and manage document classification categories for AI document analysis. These categories are used across General Source, Study Source, and other modules for document classification.",
  "docCategories.newCategory": "New Category",
  "docCategories.modal.newTitle": "New Document Category",
  "docCategories.modal.editTitle": "Edit Document Category",
  "docCategories.categoryName": "Category Name",
  "docCategories.classificationStandard": "Classification Standard (Prompt)",
  "docCategories.visibleToAllUsers": "Visible to all users",
  "docCategories.defaultSelected": "Selected by default",
  "docCategories.status.enabled": "Enabled",
  "docCategories.status.disabled": "Disabled",
  "docCategories.placeholder.name": "Enter category name, e.g. Global Standard, SOP...",
  "docCategories.placeholder.prompt":
    "Describe the classification rules the AI should use to identify and categorize documents under this type...",
  "docCategories.searchPlaceholder": "Search by name or prompt...",
  "docCategories.count": "{{count}} categories",
  "docCategories.table.name": "Category Name",
  "docCategories.table.prompt": "Classification Standard (Prompt)",
  "docCategories.table.action": "Action",
  "docCategories.empty.noMatching": "No matching categories",
  "docCategories.empty.noCategories": "No categories yet",
  "docCategories.empty.adjustSearch": "Try adjusting your search",
  "docCategories.empty.clickNew": 'Click "New Category" to create one',
  "docCategories.empty.noPrompt": "No prompt defined",
  "docCategories.empty.noPromptNeeded": "No prompt needed",
  "docCategories.empty.noPromptDefined": "No prompt defined",
  "docCategories.customCategories": "Custom Categories",
  "docCategories.systemCategories": "System Categories",
  "docCategories.systemCategoriesTooltip":
    "System categories are pre-defined by the platform and shared across all studies. They cannot be edited or deleted, and do not require classification prompts.",
  "docCategories.locked": "Locked",
  "docCategories.modal.builtInNotice":
    "This is a built-in category with restricted editing permissions.",
  "docCategories.modal.deleteTitle": "Delete this category?",
  "docCategories.modal.deleteDesc":
    "Documents currently using this category will no longer have it assigned.",

  // Document Types
  "docTypes.title": "Document Type Management",
  "docTypes.tooltip":
    "Define and manage document source types. These types are used as filter options when users select sources on the Ask page, helping them narrow down which sources to search within.",
  "docTypes.newType": "New Type",
  "docTypes.modal.newTitle": "New Document Type",
  "docTypes.modal.editTitle": "Edit Document Type",
  "docTypes.modal.deleteTitle": "Delete this type?",
  "docTypes.modal.deleteDesc": "Sources currently using this type will no longer have it assigned.",
  "docTypes.typeName": "Type Name",
  "docTypes.placeholder.name": "e.g. Legal docs, SOPs, HR Policies",
  "docTypes.searchPlaceholder": "Search by type name...",
  "docTypes.count": "{{count}} types",
  "docTypes.table.name": "Type Name",
  "docTypes.table.action": "Action",
  "docTypes.empty.noMatching": "No matching types",
  "docTypes.empty.noTypes": "No types yet",
  "docTypes.empty.adjustSearch": "Try adjusting your search",
  "docTypes.empty.clickNew": 'Click "New Type" to create one',

  // Document Tags
  "docTags.title": "Document Tag Management",
  "docTags.tooltip":
    "Define and manage document tags for AI document analysis and metadata extraction. These tags are used across General Source, Study Source, and Personal Documents for document classification and metadata extraction.",
  "docTags.newTag": "New Tag",
  "docTags.modal.newTitle": "New Document Tag",
  "docTags.modal.editTitle": "Edit Document Tag",
  "docTags.tagName": "Tag Name",
  "docTags.tagStandard": "Tag Standard (Prompt)",
  "docTags.placeholder.name": "e.g. Study Protocol Number",
  "docTags.placeholder.prompt":
    "e.g. Extract the protocol number from study documents such as CSP, CSA, or ICF. Common formats include ACE-CL-311, D5740C00001.",
  "docTags.searchPlaceholder": "Search by name or prompt...",
  "docTags.count": "{{count}} tags",
  "docTags.table.name": "Tag Name",
  "docTags.table.prompt": "Tag Standard (Prompt)",
  "docTags.table.action": "Action",
  "docTags.empty.noMatching": "No matching tags",
  "docTags.empty.noTags": "No tags yet",
  "docTags.empty.adjustSearch": "Try adjusting your search",
  "docTags.empty.clickNew": 'Click "New Tag" to create one',
  "docTags.empty.noPromptNeeded": "No prompt needed",
  "docTags.empty.noPromptDefined": "No prompt defined",
  "docTags.personalDocDescription":
    "Assign this document to its owner user. The tag value is the user's unique ID.",
  "docTags.modal.deleteTitle": "Delete this tag?",
  "docTags.modal.deleteDesc": "Documents currently using this tag will no longer have it assigned.",
  "docTags.modal.builtInNotice": "This is a built-in tag with restricted editing permissions.",
  "docTags.modal.builtInNameCannotEdit": "Built-in tag name cannot be edited.",
  "docTags.modal.noPromptNeeded":
    "This built-in tag is auto-assigned per user and does not require a prompt.",
  "docTags.modal.noPromptRequired": "This built-in tag does not require a prompt.",
  "docTags.locked": "Locked",
  "docTags.systemTags": "System Tags",
  "docTags.systemTagsTooltip":
    "System tags are pre-defined by the platform and shared across all studies. They cannot be edited or deleted, and some are auto-assigned based on document metadata.",
  "docTags.customTags": "Custom Tags",
  // Header
  "syncConfig.backToUsers": "Back to Users",
  "syncConfig.title": "Distribution Group Sync Settings",
  "syncConfig.subtitle":
    "This page lets you configure the Distribution Groups used to synchronize OpsMate users, and assign each user's region and default role based on group membership.",
  "syncConfig.reset": "Reset",

  // Common
  "syncConfig.cancel": "Cancel",
  "syncConfig.yes": "Yes",
  "syncConfig.no": "No",
  "syncConfig.statusLabel": "Status",
  "syncConfig.s1StatusLabel": "Sync Status",
  "syncConfig.enabled": "Enabled",
  "syncConfig.disabled": "Disabled",
  "syncConfig.descriptionLabel": "Description",
  "syncConfig.descriptionPlaceholder": "Optional description...",
  "syncConfig.includeNested": "Include Nested Groups",
  "syncConfig.nestedTooltip":
    "Recursively retrieve users from nested distribution groups. GroupMember.Read.All permission is required.",
  "syncConfig.emailInvalid": "Please enter a valid email",

  // Section 1
  "syncConfig.s1Title": "All User Distribution Group Sync",
  "syncConfig.s1Desc":
    "Synchronize the complete list of users permitted to access OpsMate. This creates or updates platform users.",
  "syncConfig.s1DgEmailLabel": "Distribution Group Email",
  "syncConfig.s1DgEmailRequired": "Distribution Group Email is required",
  "syncConfig.s1DgEmailPlaceholder": "e.g. all-users@company.com",
  "syncConfig.s1DgEmailTooltip":
    "Members of this group will be synchronized to the OpsMate user directory.",
  "syncConfig.s1StatusEnabledHint": "Enabled: Participate in scheduled synchronization.",
  "syncConfig.s1StatusDisabledHint":
    "Disabled: Stop subsequent automatic synchronization, but do not immediately delete existing users.",
  "syncConfig.lastSyncTime": "Last Sync Time",
  "syncConfig.lastSyncStatus": "Last Sync Status",
  "syncConfig.lastSyncSuccess": "Last Sync Success",
  "syncConfig.syncFailed": "Sync Failed",
  "syncConfig.syncedUserCount": "Synced User Count",
  "syncConfig.syncing": "Syncing...",
  "syncConfig.syncingUsers": "Syncing users from distribution group...",
  "syncConfig.loadFailed": "Failed to load sync configuration.",
  "syncConfig.saveFailed": "Failed to save sync configuration.",
  "syncConfig.syncAgain": "Sync Again",
  "syncConfig.disableSyncTitle": "Disable Sync?",
  "syncConfig.enableSyncTitle": "Enable Sync?",
  "syncConfig.disableSyncDesc":
    "This will stop automatic user synchronization. Existing users will remain in the system. You can re-enable sync at any time.",
  "syncConfig.enableSyncDesc":
    "This will resume automatic user synchronization based on the configured distribution group.",
  "syncConfig.disableSync": "Disable Sync",
  "syncConfig.enableSync": "Enable Sync",

  // Section 2
  "syncConfig.s2Title": "Region Assignment",
  "syncConfig.s2Desc":
    "Identify Hong Kong users from the synchronized user directory. Users found in the Hong Kong Distribution Group will be assigned to the Hong Kong region with the HK Staff role. All other synchronized users will be assigned to Mainland China with the Staff role.",
  "syncConfig.s2HkEmailLabel": "Hong Kong Distribution Group Email",
  "syncConfig.s2HkEmailRequired": "Hong Kong Distribution Group Email is required",
  "syncConfig.s2HkEmailPlaceholder": "e.g. hk-users@company.com",
  "users.source": "User Source",
  "users.source.all": "All User Sources",
  "syncConfig.lastSaved": "Last Saved",
  "syncConfig.pendingBanner":
    "Configuration saved. Region and role assignment will be applied to users once the user directory synchronization (All User Distribution Group Sync) completes.",
  "syncConfig.rulesTitle": "Region & Default Role Rules",
  "syncConfig.rulesDesc":
    "The system automatically assigns each user's region and default role based on their membership in the distribution groups configured above.",
  "syncConfig.rulesColClass": "Classification",
  "syncConfig.rulesColRegion": "Assigned Region",
  "syncConfig.rulesColRole": "Default Role",
  "syncConfig.rulesRow1": "User is in the Hong Kong Distribution Group",
  "syncConfig.rulesRow2": "User is not in the Hong Kong Distribution Group",
  "syncConfig.rulesRow3": "Hong Kong DG member is not found in the synchronized user directory",
  "syncConfig.regionHk": "Hong Kong",
  "syncConfig.regionMainland": "Mainland China",
  "syncConfig.regionUnmatched": "Unmatched",
  "syncConfig.roleHkStaff": "Staff",
  "syncConfig.roleStaff": "Staff",
  "syncConfig.roleNone": "No role assigned",
  "syncConfig.disableRegionTitle": "Disable Region Assignment?",
  "syncConfig.enableRegionTitle": "Enable Region Assignment?",
  "syncConfig.disableRegionDesc":
    "Newly synced users will no longer be tagged with a region or role. Existing assignments will remain.",
  "syncConfig.enableRegionDesc":
    "This will resume tagging synchronized users with their region and role.",
  "syncConfig.disable": "Disable",
  "syncConfig.enable": "Enable",

  // Permission tip
  "syncConfig.permissionTitle": "Microsoft Graph Permission Required",
  "syncConfig.permissionDesc":
    "Microsoft Graph application permission GroupMember.Read.All with administrator consent is required to read Distribution Group members and expand nested groups. This permission is read-only and does not provide access to SharePoint content, Teams messages, emails, calendars, files, or documents.",

  // Action bar
  "syncConfig.saving": "Saving...",
  "syncConfig.saveAll": "Save & Sync",
  "syncConfig.edit": "Edit",
  "syncConfig.finish": "Finish",

  // Reset modal
  "syncConfig.resetTitle": "Reset Sync Settings?",
  "syncConfig.resetDesc":
    "This clears the current User Source and Region Assignment configuration and returns the page to its unconfigured state. Saved region and role assignments will be lost.",
  "syncConfig.resetBtn": "Reset",

  "maintenance.title": "Maintenance Mode",
  "maintenance.description":
    "When enabled, non-admin users will see a maintenance page after login and cannot access any features",
  "maintenance.pageTitle": "System Under Maintenance",
  "maintenance.pageMessage":
    "The system is currently undergoing maintenance. Please try again later.",
  "maintenance.message": "Maintenance Message",
  "maintenance.messageHint": "This message is displayed to users on the maintenance page.",
  "maintenance.messageRequired":
    "Please enter a maintenance message before enabling maintenance mode.",
  "maintenance.save": "Save",
  "maintenance.saved": "Saved",
  "maintenance.saveFailed": "Unable to save the maintenance settings. Please try again.",
  "maintenance.logout": "Logout",
};

export default translation;
